import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FetchData, { CreateEntry, GetList, UpdateEntry} from "../../providers/dataProvider";
import { CheckNull } from "../../utils/Validate";
import validation from "./validation";
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";
import urls from "../../constants";

const useForm = (params) => {

  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [values, setValues] = useState({
    paymentDescription: "",
    creditDays: "",
    requiredCreditCheck: false,
    paymentTooltip: "",
    createdBy: localStorage.getItem("authidentity"),
    isActive: true,
  });
  const [show, setShow] = useState(false);
  const [createMsg, setCreateMsg] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: "",
  });
  const [editPaymentTerms, setEditPaymentTerms] = useState({
    row: null,
    id: null,
  });
  const navigate = useNavigate();
  const [listData, setListData] = useState({});

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      if (item?.id) {
        if (item?.canEdit !== true) navigate("/dashboard");
        setEditPaymentTerms({
          id: item?.id,
          row: item?.row,
        });
      } else {
        if (item?.canAdd !== true) navigate("/dashboard");
      }
    } else if (params == undefined) {
      navigate("/dashboard");
    }
  }, []);


  const handleFormChange = (e) => {
    const fieldName = e.target.name;
    setValues({
      ...values,
      [fieldName]:
        e.target.type == "checkbox" ? e.target.checked : e.target.value,
    });
    setErrors((prev) => {
      if (!prev?.[fieldName]) return prev;
      const next = { ...prev };
      delete next[fieldName];
      return next;
    });
  };


  useEffect(() => {
    if (!editPaymentTerms?.id) return;
    if (editPaymentTerms?.id) {
      setValues({
        paymentDescription: editPaymentTerms?.row?.paymentDescription,
        creditDays: editPaymentTerms?.row?.creditDays,
        requiredCreditCheck: editPaymentTerms?.row?.requiredCreditCheck,
        paymentTooltip: editPaymentTerms?.row?.paymentTooltip,
        id: editPaymentTerms?.id,
        isActive: editPaymentTerms?.row?.isActive,
        modifiedBy: editPaymentTerms?.row?.modifiedBy,
      });
    }
  }, [editPaymentTerms]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors(validation(values));
    setIsSubmit(true);
  };

  useEffect(() => {
    const errorCount = Object.values(validation(values)).filter(Boolean).length;
    if (errorCount == 0 && isSubmit) {
      if (CheckNull(values?.id) !== "") {
        setLoading(true);
        UpdateEntry(
          "paymentterms",
          values,
          setCreateMsg,
          SuccessMessages?.UPDATED("Payment terms"),
          ErrorMessages?.UPDATE_ERROR("Payment terms")
        );
      } else {
        setLoading(true);
        const valuesCopy = { ...values };
        delete valuesCopy["isActive"];
        CreateEntry(
          "paymentterms",
          valuesCopy,
          setCreateMsg,
          SuccessMessages?.CREATED("Payment terms"),
          ErrorMessages?.CREATE_ERROR("Payment terms")
        );
      }
    } else setIsSubmit(false);
  }, [errors, isSubmit, values]);

 
  useEffect(() => {
    if (createMsg?.status == urls?.SUCCESS_STATUS) {
      setShow(true);
      setValues({});
    } else if (createMsg?.status == urls?.FAILURE_STATUS || createMsg?.status == urls?.ERROR_STATUS) {
      let errorsmsg = createMsg.successData;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
    }
  }, [createMsg]);

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  const SuccessDoneClick = () => {
    setShow(false);
    setLoading(false);
    // if (createMsg?.status == 200)
    //   GetList("paymentterms", "", setListData);
    // else navigate("/payment-terms");

    navigate("/payment-terms")
  };

  return {
    values,
    setValues,
    show,
    setShow,
    createMsg,
    setCreateMsg,
    errors,
    handleFormChange,
    handleSubmit,
    errorShow,
    setErrorShow,
    ErrorDoneClick,
    SuccessDoneClick,
    listData,
    setListData,
    loading,
    setLoading,
  };
};

export default useForm;
